/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalMessage } from './PortalMessage';
import {
    PortalMessageFromJSON,
    PortalMessageFromJSONTyped,
    PortalMessageToJSON,
    PortalMessageToJSONTyped,
} from './PortalMessage';

/**
 * 
 * @export
 * @interface PortalMessagePage
 */
export interface PortalMessagePage {
    /**
     * 
     */
    messages: Array<PortalMessage>;
    /**
     * 
     */
    has_more: boolean;
}

/**
 * Check if a given object implements the PortalMessagePage interface.
 */
export function instanceOfPortalMessagePage(value: object): value is PortalMessagePage {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('has_more' in value) || value['has_more'] === undefined) return false;
    return true;
}

export function PortalMessagePageFromJSON(json: any): PortalMessagePage {
    return PortalMessagePageFromJSONTyped(json, false);
}

export function PortalMessagePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessagePage {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(PortalMessageFromJSON)),
        'has_more': json['has_more'],
    };
}

export function PortalMessagePageToJSON(json: any): PortalMessagePage {
    return PortalMessagePageToJSONTyped(json, false);
}

export function PortalMessagePageToJSONTyped(value?: PortalMessagePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(PortalMessageToJSON)),
        'has_more': value['has_more'],
    };
}

